import clsx from "clsx"
import { MediaMobile, MediaTablet } from "../../../api/const/MediaQuery"
import useMediaQuery from "../../../hook/useMediaQuery"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { useCallback, useContext, useEffect } from "react"
import { Button, Loader, TimedTooltip } from "../../atoms"
import logo from '../../../assets/logoWhite.svg'
import { AppGeneralContext } from "shared/GeneralContext/GeneralContext"
import imgLogo from './../../../assets/logo192.png';
import imgCover from './../../../assets/InnovationMatchPress.jpg';
import { useAuth } from "shared/auth"
import { LoginType } from "components/types/Context"

export const Bookingpage = () => {
    const { startupId } = useParams()

    const tablet = useMediaQuery(MediaTablet)
    const mobile = useMediaQuery(MediaMobile)
    const navigate = useNavigate()
    const { auth } = useAuth()
    const location = useLocation()
    const {
        setstartUpIdforMatch,
        setModalDatesIsOpen,
        IsLoadingGetStartupbyId,
        startUpById,
        baseUri,
        loginType,
    } = useContext(AppGeneralContext)

    useEffect(() => {
        if (!location.pathname.includes('match')) {
            return
        }
        match()
    }, [])

    useEffect(() => {
        setstartUpIdforMatch(startupId ?? "")
    }, [startupId])

    const match = useCallback(
        () => {
            if (startupId) {
                setModalDatesIsOpen(true)
                setstartUpIdforMatch(startupId)
            }
        },
        [startupId],
    )

    return (
        <div>
            {IsLoadingGetStartupbyId ?
                <div className=" w-100 d-flex align-items-center " style={{ height: "85vh" }}>
                    <Loader />
                </div>
                :

                <>
                    <div className={clsx(" m-0 p-0  container-fluid ", {
                        "me-5": !tablet,
                        "me-3": tablet
                    })}>
                        <div className={clsx("row d-flex m-0 p-0 align-items-center flex-wrap pe-3 pb-0", {
                            "mt-5": !tablet,
                            "mt-3": tablet
                        })}>
                            <div className={clsx('d-flex m-0 p-0 col-12')}>
                                <h3>Welcome to <span className='tx-primary'>{startUpById?.name}</span></h3>
                            </div>
                        </div>
                        <div className={clsx("row d-flex m-0 p-0  start-up-profile-container   pe-3 pb-0", {
                            "mt-3": !tablet,
                            "mt-2": tablet
                        })}>
                            <div className={clsx('d-flex m-0 p-0 ', {
                                " col-7 pe-2": !tablet,
                                " col-12": tablet
                            })}>
                                <div className='image-container position-relative mb-5'>
                                    <img className='w-100' src={startUpById?.coverUrl ? `${baseUri}${startUpById?.coverUrl}` : imgCover} alt="start up image" />
                                    <div className='img-logo'>
                                        <img className='w-100' src={startUpById?.logoUrl ? `${baseUri}${startUpById?.logoUrl}` : imgLogo} alt="logo startup" />
                                    </div>
                                </div>
                            </div>
                            <div className={clsx('d-flex  flex-column justify-content-start align-items-center  pb-1 m-0 p-0 h-100', {
                                " col-5 ": !tablet,
                                " col-12": tablet
                            })}>
                                {loginType !== LoginType.guest && <div className="row  w-100 m-0 p-0 pb-2 ">
                                    <div className={'d-flex col-12 flex-column justify-content-start align-items-start  pb-1 m-0 p-0 h-100'}>
                                        <h5 className='fw-700 mt-0'>City:</h5>
                                        <p className='department m-0 p-0'>{startUpById?.city?.label}</p>
                                    </div>
                                </div>}
                                <div className="row  w-100 m-0 p-0">
                                    <div className={clsx('d-flex flex-column justify-content-start align-items-start  m-0 p-0 h-100', {
                                        " col-6 pe-3": !tablet,
                                        " col-12 pe-0": tablet
                                    })}>
                                        <h5 className='fw-700 '>Industry:</h5>
                                        <p className='department m-0 p-0'>{startUpById?.sector?.label}</p>
                                    </div>
                                    <div className={clsx('d-flex  flex-column justify-content-start align-items-start  m-0 p-0 h-100', {
                                        " col-6 ": !tablet,
                                        " col-12 ": tablet
                                    })}>
                                        <h5 className={clsx('fw-700 ', {
                                            "mt-2": tablet
                                        })}>
                                            Status:
                                        </h5>
                                        <p className='department '>{startUpById?.constitutionStatus?.label}</p>
                                    </div>
                                </div>
                                <div className="row  w-100 m-0 p-0 ">
                                    <div className={'d-flex col-12 flex-column justify-content-start align-items-start  pb-1 m-0 p-0 h-100'}>
                                        <h5 className='fw-700 mt-0'>Description:</h5>
                                        <p>{startUpById?.description}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row  w-100 m-0 p-0 ">
                            <div className={'d-flex col-12 mb-2   pe-3 flex-column justify-content-start align-items-start  pb-1 m-0 p-0 h-100'}>
                                <h5 className='fw-700 mt-0'>Pitch:</h5>
                                <p className='mb-4 pe-1'>{startUpById?.pitch}</p>
                            </div>
                        </div>
                    </div>
                    <div className={clsx(" m-0 p-0  container-fluid ", {
                        "pe-4 pb-5": !tablet,
                        "pe-3": tablet
                    })}>
                        <div className={" m-0 p-0 row d-flex tag-container "}>
                            <div className="col-12 d-flex  mt-4 mb-4" >
                                <h5 className='fw-700  '>Tags:</h5>
                                <ul className='d-flex flex-wrap' style={{ listStyleType: "none" }} >
                                    {startUpById?.tags?.map((tag) => {
                                        return <li key={tag.value} className='tag'>{tag.label}</li>
                                    })}
                                </ul>
                            </div>
                        </div>
                        <div className={clsx("d-flex pt-4  ",
                            { "justify-content-end flex-row": !mobile },
                            { "justify-content-center align-items-end flex-column mb-5": mobile })}>
                            {auth?.jwtToken && <Button disabled={auth?.jwtToken ? false : true} onClick={() => navigate("/corporate/profile")} className='card-button__profile' removePadding uppercase background='var(--white)' text='GO BACK' />}
                            {startUpById?.unmatchableReason ?
                                <TimedTooltip
                                    text={startUpById?.unmatchableReason}
                                    childeren={
                                        <Button disabled={!startUpById?.canMatch} onClick={() => match()} borderColor='transparent' className='card-button' removePadding uppercase background='var(--primary)' icon={logo} primary color='var(--white)' text='match' removeRotate />
                                    } /> :
                                <Button disabled={!startUpById?.canMatch} onClick={() => match()} borderColor='transparent' className='card-button' removePadding uppercase background='var(--primary)' icon={logo} primary color='var(--white)' text='match' removeRotate />
                            }
                        </div>
                        {tablet && <div style={{ height: " 20vh" }} />}
                    </div>
                </>
            }
        </div>
    )

}
